// Check bundle
// Buy pintura and install (update deps, remove old library)
// Update org descriptiosn
// Add HTML view to org show
import React, { Suspense } from 'react';

import { useQuery } from '@apollo/client';

import DataLoader from '@ivy/components/molecules/DataLoader';
import { useCurrentAccount } from '@ivy/gql/hooks';
import { gql } from '@ivy/gql/types';
import { useNotifyError } from '@ivy/lib/hooks';
import lazyRetry from '@ivy/lib/util/lazyRetry';

import { type EditEmployerProfilePopupHelperProps } from './EditEmployerProfilePopupHelper';

const EditEmployerPopupProfileHelper = lazyRetry(
	() => import('./EditEmployerProfilePopupHelper'),
	'EditEmployerProfilePopup_EditEmployerProfilePopupHelper',
);

const EditEmployerProfilePopup_OrganizationProfileQDoc = gql(/* GraphQL */ `
	query EditEmployerProfilePopup_OrganizationProfile($orgId: uuid!) {
		org: organization_by_pk(id: $orgId) {
			id
			...EditEmployerProfileForm_Organization
		}
	}
`);

type EditEmployerProfilePopupProps = Omit<
	EditEmployerProfilePopupHelperProps,
	'org'
>;

const EditEmployerProfilePopup = ({
	open,
	...props
}: EditEmployerProfilePopupProps) => {
	const currAcc = useCurrentAccount();
	const { data, loading, error } = useQuery(
		EditEmployerProfilePopup_OrganizationProfileQDoc,
		{
			variables: {
				orgId: currAcc?.orgUser?.org.id,
			},
			// Use network only to reflect any changes they just made
			fetchPolicy: 'network-only',
		},
	);
	useNotifyError(error);

	return (
		<Suspense
			fallback={
				open ? <DataLoader fullscreen variant='circular' transparent /> : null
			}
		>
			<DataLoader
				data={data}
				loading={loading}
				error={error}
				fullscreen
				variant='circular'
				transparent
			>
				{!!data?.org && (
					<EditEmployerPopupProfileHelper
						org={data!.org!}
						open={open}
						{...props}
					/>
				)}
			</DataLoader>
		</Suspense>
	);
};

export default EditEmployerProfilePopup;
export { type EditEmployerProfilePopupProps };
